export enum SaleResultEnum {
  NoResult = 0,
  Sold = 1,
  PassedIn = 2,
  Withdrawn = 3,
  WithdrawnAtSale = 4,
  PrivateSale = 5
}
